import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import * as accountData from '@/store/modules/accountDataStore';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    accountData
  },
  state,
  getters,
  mutations,
  actions
});
